import React, { useContext } from 'react';
import classes from './PageLayout.module.scss';
import { TopNavContext } from '../../../providers/TopNavProvider';
import { MandatoryChildren } from '../../../models/children-props';
import classNames from 'classnames';
import { useTopNavClasses } from '../../../hooks/useTopNavClasees';

export type PageLayoutViewProps = MandatoryChildren<{
  //
}>;

export const PageLayoutView = (props: PageLayoutViewProps): JSX.Element => {
  const { children } = props;
  const { state: topNavOffsetState } = useContext(TopNavContext);
  const topNavClasses = useTopNavClasses(topNavOffsetState);

  const pageClasses = classNames(classes.PageLayout, topNavClasses.vheight, topNavClasses.top);

  return <div className={pageClasses}>{children}</div>;
};
